import {FC} from 'react'
import {CreditOverview} from '../../../../../services/cellcast.v2.types'
import {Card, Spinner} from 'react-bootstrap'
import { FixedTwoDecimal } from '../../../../Utils/_helpers/string'

export type OverviewProps = {
  isFetching: boolean
  credit: CreditOverview
}

const Overview: FC<OverviewProps> = ({isFetching, credit}) => {
  return (
    <Card className='mb-6'>
      {isFetching ? (
        <Card.Body className='pt-9 pb-0 h-500'>
          <div className='d-flex flex-wrap flex-sm-nowrap flex-column align-items-center  mb-10'>
            <Spinner className='mb-5' />
            <span>Fetching data ....</span>
          </div>
        </Card.Body>
      ) : (
        <Card.Body>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                      Account overview
                    </span>
                  </div>
                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <span className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                      Activity of an time
                    </span>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1'>
                  <div className='d-flex flex-wrap justify-content-between gap-3'>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value='1378.73'
                          data-kt-countup-prefix='$'
                        >
                          {FixedTwoDecimal(credit.allocatedSms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Total Allocated Sms</div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value='1378.73'
                          data-kt-countup-prefix='$'
                        >
                          {FixedTwoDecimal(credit.allocatedMms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Total Allocated Mms</div>
                    </div>
                     <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value='1378.73'
                          data-kt-countup-prefix='$'
                        >
                          {FixedTwoDecimal(credit.purchasedSms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Total Purchased Sms</div>
                    </div>
                     <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value='1378.73'
                          data-kt-countup-prefix='$'
                        >
                          {FixedTwoDecimal(credit.purchasedMms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Total Purchased Mms</div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={480}
                        >
                          {FixedTwoDecimal(credit.usedSms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>SMS sent</div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                      <div className='d-flex align-items-center'>
                        <div
                          className='fs-2 fw-bolder counted'
                          data-kt-countup='true'
                          data-kt-countup-value={480}
                          data-kt-countup-prefix='%'
                        >
                          {FixedTwoDecimal(credit.usedMms)}
                        </div>
                        <span className='svg-icon svg-icon-3 svg-icon-success ms-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <rect
                              opacity='0.5'
                              x={13}
                              y={6}
                              width={13}
                              height={2}
                              rx={1}
                              transform='rotate(90 13 6)'
                              fill='currentColor'
                            />
                            <path
                              d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>MMS sent</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      )}
    </Card>
  )
}

export default Overview
